import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {onError} from 'util'
import loading from 'util/loading'
import {form} from 'util/decorator'
import store from 'store'
import {login} from 'util/admin-session-api'

@form
@observer
export default class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      submitting: false
    }
  }
  onSubmit(e, obj) {
    e.preventDefault()
    let {username, password} = obj
    if (!username.trim() || !password.trim()) {
      this.setState({
        error: '请输入用户名和密码'
      })
      return
    }
    this.setState({
      error: '',
      submitting: true
    })
    let hide = loading()
    login(username, password).then(user => {
      hide()
      this.setState({submitting: false})
      store.setUser(user)
    }, err => {
      hide()
      this.setState({
        submitting: false,
        error: err.status == 401 ? '用户名密码不匹配' : (err.message || '后台服务暂不可用，请稍后重试')
      })
      if (err.status == 401) {
        return
      }
      onError(err)
    })
  }
  render() {
    let {error, submitting} = this.state
    return (
      <form id="login-form" onSubmit={::this.onSubmit}>
        {do{
          if (error) {
            <div class="error" role="alert" aria-live="assertive">{error}</div>
          }
        }}
        <div class="form-group">
          <label class="login-label" htmlFor="login-username">用户名</label>
          <input class="input"
            id="login-username"
            type="text"
            name="username"
            autoComplete="username"
            placeholder="用户名"
          />
        </div>
        <div class="form-group">
          <label class="login-label" htmlFor="login-password">密码</label>
          <input class="input"
            id="login-password"
            type="password"
            name="password"
            autoComplete="current-password"
            placeholder="密码"
          />
        </div>
        <div class="btn-group">
          <input type="submit" class="btn login-btn" value={submitting ? '登录中...' : '登录'} disabled={submitting} />
        </div>
      </form>
    )
  }
}
